import {
  IonActionSheet,
  IonButton,
  IonCheckbox,
  IonIcon,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonTextarea
} from '@ionic/react'
import Container from 'layouts/containers/Container'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { RouteComponentProps, useHistory } from 'react-router'
import LayoutDefault from 'layouts/LayoutDefault'
import { imageOutline, trash } from 'ionicons/icons'
import { scoringApi, controlApi } from 'api/user'
import { useSelector } from 'react-redux'
import { RootState } from 'stores/reducers'
import { CONTROLLER, getRole } from 'utils/const'
import store from 'stores/store'
import { delCurrentProfession, delOnGoingScoring } from 'stores/actions/user'
import { getCalloutScoring } from 'api/callout'
import { PhotoInterface, usePhotoGallery } from '../../hooks/usePhotoGallery'
import SignatureCanvas from 'react-signature-canvas'

interface MatchParams {
  calloutID: string
}

interface CheckboxParams {
  name: string
  value?: boolean
}

interface InputParams {
  type?: string
  name: string
  required: boolean
  index: number
  value?: string
  child_fields?: Array<CheckboxParams>
  files?: any
}

const toBase64 = (file: any): Promise<any> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const ScoringSubmission: React.FC<
  RouteComponentProps<MatchParams, any, any>
> = ({ match, location }) => {
  const router = useHistory()
  const [form, setform] = useState<InputParams[]>([])
  const [signature, setSignature] = useState(false)
  const [place, setPlace] = useState<string>('')
  const [loading, setloading] = useState(false)
  const [, seterror] = useState(false)

  const handleChange = (value: any, index: number) => {
    const newForm = form
    newForm[index].value = value
    setform(newForm)
  }

  const state = useSelector((state: RootState) => state)
  const role = getRole(state.user.role)

  const handleCheckChange = (
    value: any,
    index: number,
    child_index: number
  ) => {
    const newForm = form
    newForm[index].child_fields![child_index].value = value
    setform(newForm)
  }

  const handleFiles = async (input: any, index: number) => {
    const newForm = form
    const files = Array.from(input.files)
    const files64: Array<string> = []

    for (const file of files) {
      const base64 = await toBase64(file)
      files64.push(base64)
    }

    newForm[index].files = files64

    // To force react to rerender
    const rerenderNewForm = [...newForm]

    setform(rerenderNewForm)
  }

  const InputText = ({ name, required, index }: InputParams) => {
    return (
      <IonItem>
        <IonLabel position="floating">{name + (required ? ' *' : '')}</IonLabel>
        <IonInput
          placeholder="Votre réponse"
          value={form[index].value}
          onIonChange={(e) => handleChange(e.detail.value!, index)}
        />
      </IonItem>
    )
  }

  const InputTextarea = ({ name, required, index }: InputParams) => {
    return (
      <IonItem>
        <IonLabel position="floating">{name + (required ? ' *' : '')}</IonLabel>
        <IonTextarea
          autoGrow
          placeholder="Votre réponse"
          value={form[index].value}
          onIonChange={(e) => handleChange(e.detail.value!, index)}
        />
      </IonItem>
    )
  }

  const InputCheckbox = ({
    name,
    required,
    index,
    child_fields
  }: InputParams) => {
    return (
      <div className="vertical-margin-20">
        <IonItem lines="none">
          <IonLabel>{name + (required ? ' *' : '')}</IonLabel>
        </IonItem>
        <IonList>
          {child_fields?.map((child, child_index) => (
            <IonItem key={child_index}>
              <IonLabel>{child.name}</IonLabel>
              <IonCheckbox
                checked={child.value}
                onIonChange={(e) =>
                  handleCheckChange(e.detail.checked, index, child_index)
                }
              />
            </IonItem>
          ))}
        </IonList>
      </div>
    )
  }

  const InputRadio = ({
    name,
    required,
    index,
    child_fields,
    value
  }: InputParams) => {
    return (
      <div className="vertical-margin-20">
        <IonItem lines="none">
          <IonLabel>{name + (required ? ' *' : '')}</IonLabel>
        </IonItem>
        <IonList>
          {/* C'est la IonRadioGroup qui contient le state du choix du champ */}
          <IonRadioGroup
            value={value}
            onIonChange={(e) => handleChange(e.detail.value, index)}>
            {child_fields?.map((child, child_index) => (
              <IonItem key={child_index}>
                <IonLabel>{child.name}</IonLabel>
                <IonRadio value={child} />
              </IonItem>
            ))}
          </IonRadioGroup>
        </IonList>
      </div>
    )
  }

  const InputPhoto = ({ name, required, index, files }: InputParams) => {
    const fileInput = useRef(null)

    const { photos, takePhoto, deletePhoto, setPhotos } = usePhotoGallery()
    useEffect(() => {
      setPhotos(files)
    }, [files, setPhotos])

    const [photoToDelete, setPhotoToDelete] = useState<PhotoInterface>()

    // on met à jour les photos dans le form
    form[index].files = photos

    return (
      <div className="vertical-margin-20">
        <IonItem lines="none">
          <IonLabel>{name + (required ? ' *' : '')}</IonLabel>
        </IonItem>
        <IonItem>
          <input
            ref={fileInput}
            hidden
            multiple
            type="file"
            accept="image/*"
            onChange={(e) => handleFiles(e.nativeEvent.target, index)}
          />
          <IonButton
            color="light"
            onClick={() => {
              // @ts-ignore
              // fileInput?.current?.click()
              takePhoto()
            }}>
            <IonIcon slot="start" icon={imageOutline} />
            Ajouter une image
          </IonButton>
        </IonItem>

        {photos.length > 0 ? (
          <div className="list-img">
            <IonItem lines="none">
              <div>
                {photos.map((photo, index) => (
                  <div key={index} className="image-delete-wrapper">
                    <IonImg
                      src={photo.webviewPath}
                      onClick={() => setPhotoToDelete(photo)}
                      className="ion-margin-vertical"
                    />
                    <span className="image-delete"></span>
                  </div>
                ))}
              </div>
            </IonItem>
          </div>
        ) : null}

        <IonActionSheet
          isOpen={!!photoToDelete}
          buttons={[
            {
              text: 'Effacer',
              role: 'destructive',
              icon: trash,
              handler: () => {
                if (photoToDelete) {
                  deletePhoto(photoToDelete)
                  setPhotoToDelete(undefined)
                }
              }
            }
          ]}
          onDidDismiss={() => setPhotoToDelete(undefined)}
        />
      </div>
    )
  }

  const displayForm = useMemo(() => {
    return form.map((input, index) => {
      switch (input.type) {
        case 'text':
          return (
            <InputText
              key={index}
              name={input.name}
              required={input.required}
              index={index}
            />
          )

        case 'textarea':
          return (
            <InputTextarea
              key={index}
              name={input.name}
              required={input.required}
              index={index}
            />
          )

        case 'checkbox':
          return (
            <InputCheckbox
              key={index}
              name={input.name}
              required={input.required}
              index={index}
              child_fields={input.child_fields}
            />
          )

        case 'radio':
          return (
            <InputRadio
              key={index}
              name={input.name}
              required={input.required}
              index={index}
              child_fields={input.child_fields}
              value={input.value}
            />
          )

        case 'photo':
          return (
            <InputPhoto
              key={index}
              name={input.name}
              required={input.required}
              index={index}
              child_fields={input.child_fields}
              value={input.value}
              files={input.files || []}
            />
          )

        default:
          return ''
      }
    })
  }, [form]);

  const submit = () => {
    if (role === CONTROLLER) {
      submitController()
    } else {
      submitIntervenant()
    }
  }

  const submitIntervenant = () => {
    setloading(true)
    seterror(false)

    scoringApi(match.params.calloutID, form)
      .then(() => {
        store.dispatch(delCurrentProfession())
        store.dispatch(delOnGoingScoring())
        // Redirect
        router.push(`/${role}`)
      })
      .catch(() => {
        seterror(true)
        setloading(false)
      })
  }


  const submitController = () => {
    setloading(true)
    seterror(false)

    let signatureCanvas, valid
    // vérif bouton radio et signature
    if (typeof validControl === 'boolean') {
      if (signature) {
        if (sigDraw) {
          //@ts-ignore
          signatureCanvas = sigRef.current.getTrimmedCanvas().toDataURL()
        } else {
          setloading(false)
          return false
        }
      }

      valid = validControl
    } else {
      setloading(false)
      return false
    }

    controlApi(match.params.calloutID, form, valid, signatureCanvas)
      .then(() => {
        store.dispatch(delCurrentProfession())
        store.dispatch(delOnGoingScoring())
        // Redirect
        router.push(`/${role}`)
      })
      .catch(() => {
        seterror(true)
        setloading(false)
      })
  }

  useEffect(() => {
    // si le formulaire existe déjà, pas besoin de le réinit
    if (!form.length) {
      // Init radio inputs
      if (location.state && location.state.form && location.state.place) {
        location.state.form.forEach((input: InputParams, index: number) => {
          if (input.type === 'radio') {
            location.state.form[index].value = input.child_fields![0]?.name
          }
        })
        setform(location.state.form)
        setPlace(location.state.place)
      } else {
        // Si le form n'est pas dans les params on le récupère par api
        getCalloutScoring(match.params.calloutID).then((data: any) => {
          data.form.forEach((input: InputParams, index: number) => {
            if (input.type === 'radio') {
              data.form[index].value = input.child_fields![0]?.name
            }
          })
          setform(data.form)
          setPlace(data.place)
          setSignature(data.signatureRequired)
        })
      }
    }
  }, [match.params, location, form])

  // if (error) {
  //   return (
  //     <Container center>
  //       <p className="ion-text-center">Une erreur a eu lieu</p>
  //       <IonButton onClick={fetchJobs}>Réessayer</IonButton>
  //     </Container>
  //   )
  // }
  

  

  // RENDU SIGNATURE ELECTRONIQUE
  const sigWrapperRef = useRef<HTMLDivElement>(null)
  const sigRef = useRef(null)
  const [canW, setCanW] = useState(0)
  // const [penColor, setPenColor] = useState('')
  const [sigDraw, setSigDraw] = useState(false)
  useEffect(() => {
    //setTimeout pour être sur que la div est bien rendue
    setTimeout(() => {
      // @ts-ignore
      let width = sigWrapperRef?.current
        ? sigWrapperRef?.current?.offsetWidth
        : window.innerWidth - 60;

      // @ts-ignore
      // let color = sigWrapperRef.current ? window.getComputedStyle(sigWrapperRef.current).color : ''
      setCanW(width);
      // console.log(window.innerWidth);
      // setPenColor(color);
    }, 500)
  }, [canW])

  const renderElectronicSignature = () => {
    if (role !== CONTROLLER || !signature) {
      return null
    }

    const onEnd = () => {
      setSigDraw(true);
    }
    const clear = () => {
      setSigDraw(false)
      //@ts-ignore
      sigRef.current.clear()
    }
    return (
      <div ref={sigWrapperRef} className="sig-wrapper" >
        {sigDraw && (
          <div className="sig-clear" onClick={clear}>
            <IonIcon icon={trash} />
            <span>effacer</span>
          </div>
        )}
        <IonItem lines="none">
          <IonLabel>Signature électronique * :</IonLabel>
        </IonItem>
        {canW > 0 ? (
          <SignatureCanvas
            backgroundColor="rgba(255,255,255)"
            ref={sigRef}
            canvasProps={{ width: canW, height: 200, className: 'sig-canvas' }}
            onEnd={onEnd}
          />
        ) : null}
      </div>
    )
  }

  // RENDU CONTROLE CONFORME
  
  const [validControl, setValidControl] = useState();

  const renderCompliantControl = useMemo(() => {
    if (role !== CONTROLLER) {
      return null
    }

    return (
      <div className="vertical-margin-20">
        <IonItem lines="none" id="conforme">
          <IonLabel>Contrôle conforme ? *</IonLabel>
        </IonItem>
        <IonList>
          <IonRadioGroup
            value={validControl}
            onIonChange={(e) => setValidControl(e.detail.value)}
            >
            <IonItem>
              <IonLabel>Oui</IonLabel>
              <IonRadio value={true} />
            </IonItem>
            <IonItem>
              <IonLabel>Non</IonLabel>
              <IonRadio value={false} />
            </IonItem>
          </IonRadioGroup>
        </IonList>
      </div>
    )
  }, [validControl, role])
  
  


  return (
    <LayoutDefault>
      <Container paddingTop paddingBottom loading={loading}>
        {place && (
          <h3>
            Veuillez remplir ce formulaire pour l'intervention: <br />
            {place}
          </h3>
        )}
        {displayForm}
        {renderCompliantControl}
        {renderElectronicSignature()}
        <IonButton className="ion-margin-top full" onClick={submit}>
          Envoyer
        </IonButton>
      </Container>
    </LayoutDefault>
  )
}

export default ScoringSubmission
